import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 border-t border-navy-800" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="max-w-4xl mx-auto text-center" data-id="element-57">
          <p className="text-gray-400 font-medium mb-6" data-id="element-58">
            © 2026 Football Ready: System 365 — All Rights Reserved.
          </p>

          <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-59">
            Football Ready: System 365 is an educational coaching resource
            created to support football coaches in planning, organizing, and
            delivering training sessions. It is not a substitute for official
            coaching certification, safeguarding requirements, or governing body
            regulations.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-60">
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-61">
              Terms & Conditions
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-62">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-63">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}